// Calibrated lookup-table version of the Capacity Cost Simulator math for the
// landing page preview. The full prototype lives in the ScopeWorth.DesignSystem
// repo (web/simulator/) — the
// numbers here are spot-tuned against compute() at default feature config
// (parallel 0.55, complexity medium, baseline N=4 → 12 wks).
import { t } from './i18n/useT.js';

export const CAPACITY = {
  baselineN: 4,
  baseWeeks: 12.0,
  baseCost: 67948,
  range: { min: 2, max: 9 },

  curve: [
    { n: 2, weeks: 16.5 },
    { n: 3, weeks: 13.5 },
    { n: 4, weeks: 12.0 },
    { n: 5, weeks: 11.4 },
    { n: 6, weeks: 11.1 },
    { n: 7, weeks: 11.2 },
    { n: 8, weeks: 11.5 },
    { n: 9, weeks: 12.0 },
  ],

  // totalCost / weeks / timeSaved are sourced directly from the prototype's
  // computed scenarios so $/wk-saved rounds match the original screenshot.
  scenarios: [
    { id: 'base', n: 4, name: t('capacityWidget.scenarios.base.name'), sub: t('capacityWidget.scenarios.base.sub'), tone: 'base', badge: 'No change',
      weeks: 12.0, timeSaved: 0,    totalCost: 67948  },
    { id: 'a',    n: 5, name: t('capacityWidget.scenarios.a.name'),    sub: t('capacityWidget.scenarios.a.sub'),    tone: 'rec',  badge: 'Recommended',
      weeks: 11.4, timeSaved: 0.6415, totalCost: 91901  },
    { id: 'b',    n: 7, name: t('capacityWidget.scenarios.b.name'),    sub: t('capacityWidget.scenarios.b.sub'),    tone: 'warn', badge: 'Trade‑offs',
      weeks: 11.2, timeSaved: 0.7565, totalCost: 150755 },
    { id: 'c',    n: 8, name: t('capacityWidget.scenarios.c.name'),    sub: t('capacityWidget.scenarios.c.sub'),    tone: 'bad',  badge: 'Not recommended',
      weeks: 11.5, timeSaved: 0,    totalCost: 187704 },
  ],

  copy: {
    base: {
      title: t('capacityWidget.copy.base.title'),
      body:  t('capacityWidget.copy.base.body'),
    },
    a: {
      title: t('capacityWidget.copy.a.title'),
      body:  t('capacityWidget.copy.a.body'),
    },
    b: {
      title: t('capacityWidget.copy.b.title'),
      body:  t('capacityWidget.copy.b.body'),
    },
    c: {
      title: t('capacityWidget.copy.c.title'),
      body:  t('capacityWidget.copy.c.body'),
    },
  },

  weeksFor(n)     { return this.curve.find(p => p.n === n).weeks; },
  costForScenario(id) { return this.scenarioById(id).totalCost; },
  timeSaved(n)    { return Math.max(0, this.baseWeeks - this.weeksFor(n)); },
  extraCostScenario(id) { return Math.max(0, this.costForScenario(id) - this.baseCost); },
  perWeekSavedScenario(id) {
    const s = this.timeSaved(this.scenarioById(id).n);
    return s > 0.05 ? this.extraCostScenario(id) / s : null;
  },
  coordRisk(n)    { return Math.min(0.50, 0.10 + 0.06 * Math.max(0, n - 3)); },
  confidence(n)   { return n <= 5 ? 'Medium' : 'Low'; },

  scenarioById(id) { return this.scenarios.find(s => s.id === id); },
  scenarioByN(n)   { return this.scenarios.find(s => s.n === n); },
};
